import React, { useEffect } from 'react'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

import { MFStar } from '../../../../assets/svgs/landingV2/business'
import {
  MFImage1,
  MFImage2,
  MFImage3,
  MFImage4,
  MFImage5,
  MFImage6,
} from '../../../../assets/images/landingV2/business'
import './styles.scss'
import './responsiveStyles.scss'

function MainFeatures() {
  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger)
    const leftTargets = gsap.utils.toArray('.bl_mf__features_acordion_content')
    const leftMiddleTargets = leftTargets
    const leftFirst = leftMiddleTargets.shift()
    const leftLast = leftMiddleTargets.pop()

    const rightTargets = gsap.utils.toArray('.bl_mf__features_right_image')
    const rightMiddleTargets = rightTargets
    const rightFirst = rightMiddleTargets.shift()
    const rightLast = rightMiddleTargets.pop()

    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: '.bl_mf',
        scrub: 0.3,
        start: 'top top',
        end: '+=2000',
        markers: false,
        pin: true,
      },
    })
    timeline
      .add('first')
      .to(leftFirst, { display: 'none', duration: 1 }, 'first')
      .to(rightFirst, { display: 'none', duration: 1 }, 'first')
      .add('second')
      .to(
        leftMiddleTargets,
        {
          className: 'bl_mf__features_acordion_content bl_mf__features_acordion_content-active',
          duration: 1,
          stagger: {
            each: 2,
            yoyo: true,
            repeat: 1,
          },
        },
        'second'
      )
      .to(
        rightMiddleTargets,
        {
          className: 'bl_mf__features_right_image bl_mf__features_right_image-active',
          duration: 1,
          stagger: {
            each: 2,
            yoyo: true,
            repeat: 1,
          },
        },
        'second'
      )
      .add('third')
      .to(
        leftLast,
        {
          className: 'bl_mf__features_acordion_content bl_mf__features_acordion_content-active',
          duration: 1,
        },
        'third'
      )
      .to(
        rightLast,
        {
          className: 'bl_mf__features_right_image bl_mf__features_right_image-active',
          duration: 1,
        },
        'third'
      )
  }, [])

  return (
    <div id='features' className='bl_mf'>
      <div className='bl_mf__title'>
        <h1>Основні можливості</h1>
      </div>
      <div className='bl_mf__features'>
        <div className='bl_mf__features_left'>
          <div className='bl_mf__features_acordion'>
            <div className='bl_mf__features_acordion_title'>
              <img src={MFStar} />
              <h3>Інформаційна панель</h3>
            </div>
            <div className='bl_mf__features_acordion_content bl_mf__features_acordion_content-active'>
              <p>
                Тут Ви можете переглядати фінансову звітність, повну інформацію по замовленням, ефективність роботи
                барист, зручно в одному місці.
              </p>
              <div className='bl_mf__features_acordion_image'>
                <img src={MFImage1} alt='Image' />
              </div>
            </div>
          </div>
          <div className='bl_mf__features_acordion'>
            <div className='bl_mf__features_acordion_title'>
              <img src={MFStar} />
              <h3>Відгуки гостей</h3>
            </div>
            <div className='bl_mf__features_acordion_content'>
              <p>
                Власник кав&apos;ярні має можливість переглядати відгуки гостей про свою кав&apos;ярню. Також, окремо
                має можливість переглядати відгуки про барист, що надає корисну інформацію по покращенню сервісу і
                задоволення гостей.
              </p>
              <div className='bl_mf__features_acordion_image'>
                <img src={MFImage2} alt='Image' />
              </div>
            </div>
          </div>
          <div className='bl_mf__features_acordion'>
            <div className='bl_mf__features_acordion_title'>
              <img src={MFStar} />
              <h3>Онлайн оплата замовлення</h3>
            </div>
            <div className='bl_mf__features_acordion_content'>
              <p>
                Ми використовуємо платіжну систему LiqPay, за допомогою якої гості мають можливість робити оплату
                замовлення онлайн, при завершенні замовлення кошти автоматично приходять на рахунок кав&apos;ярні.
              </p>
              <div className='bl_mf__features_acordion_image'>
                <img src={MFImage3} alt='Image' />
              </div>
            </div>
          </div>
          <div className='bl_mf__features_acordion'>
            <div className='bl_mf__features_acordion_title'>
              <img src={MFStar} />
              <h3>Керуйте меню або синхронізуйте з Poster</h3>
            </div>
            <div className='bl_mf__features_acordion_content'>
              <p>
                Pinka надає усі можливості керуванням меню Вашого закладу. Також, якщо Ви користуєтесь системою Poster,
                Ви маєте можливість імопртувати дані. Це дозволить керувати Вашим меню централізовано в одному місці.
              </p>
              <div className='bl_mf__features_acordion_image'>
                <img src={MFImage4} alt='Image' />
              </div>
            </div>
          </div>
          <div className='bl_mf__features_acordion'>
            <div className='bl_mf__features_acordion_title'>
              <img src={MFStar} />
              <h3>Автоматична фіскалізація з Checkbox</h3>
            </div>
            <div className='bl_mf__features_acordion_content'>
              <p>
                Ви можете фіскалізувати замовлення звичною Вам ПРРО системою. Для автоматизації фіскалізації ми додали
                можливість інтеграції з системою Checkbox. З Checkbox баристі не потрібно вручну фіскалізувати
                замовлення через ПРРО, замовлення автоматично фіскалізується при завершенні, баристі залишається лише
                віддати замовлення задоволеному гостю.
              </p>
              <div className='bl_mf__features_acordion_image'>
                <img src={MFImage5} alt='Image' />
              </div>
            </div>
          </div>
          <div className='bl_mf__features_acordion'>
            <div className='bl_mf__features_acordion_title'>
              <img src={MFStar} />
              <h3>Система лояльності</h3>
            </div>
            <div className='bl_mf__features_acordion_content'>
              <p>
                Як власник кав&apos;ярні Ви можете збільшити кількість постійних гостей, під&apos;єднавшись до системи
                лояльності. Геймифікована система лояльності додатково мотивуватиме гостей приходити саме у Вашу
                кав&apos;ярню.
              </p>
              <div className='bl_mf__features_acordion_image'>
                <img src={MFImage6} alt='Image' />
              </div>
            </div>
          </div>
        </div>
        <div className='bl_mf__features_right'>
          <div className='bl_mf__features_right_image bl_mf__features_right_image-active'>
            <img src={MFImage1} alt='Image' />
          </div>
          <div className='bl_mf__features_right_image'>
            <img src={MFImage2} alt='Image' />
          </div>
          <div className='bl_mf__features_right_image'>
            <img src={MFImage3} alt='Image' />
          </div>
          <div className='bl_mf__features_right_image'>
            <img src={MFImage4} alt='Image' />
          </div>
          <div className='bl_mf__features_right_image'>
            <img src={MFImage5} alt='Image' />
          </div>
          <div className='bl_mf__features_right_image'>
            <img src={MFImage6} alt='Image' />
          </div>
        </div>
      </div>
    </div>
  )
}

export default MainFeatures
